import md5 from 'js-md5';

/* eslint-disable */
/* ---------- 签名算法 ---------- */
var XHSign = function (params, key) {
    var aString = Object.keys(params).filter(function (key) {
        return (key !== "sign" && key !== "sign_type" && key !== "" && key !== null && params[key] !== "");
    }).sort().reduce(function (prev, cur) {
        // 后端空字符串过滤 0 为值
        if (params[cur] || params[cur] === 0) {
            return prev + "".concat(cur, "=").concat(params[cur], "&");
        }
        else {
            return prev;
        }
    }, "");
    return md5("".concat(aString).concat(key));
};

export { XHSign };
